import {
  eachDayOfInterval,
  eachWeekOfInterval,
  eachMonthOfInterval,
  format,
} from 'date-fns';

export const generateDateRange = (start, end, granularity) => {
  let dates;

  switch (granularity) {
    case 'DAY':
      dates = eachDayOfInterval({ start, end });
      break;
    case 'WEEK':
      dates = eachWeekOfInterval({ start, end }, { weekStartsOn: 1 }); // start on monday
      break;
    case 'MONTH':
      dates = eachMonthOfInterval({ start, end });
      break;
    default:
      throw new Error('Invalid granularity');
  }

  return dates.map((date) => format(date, 'yyyy-MM-dd'));
};
